import React from 'react';

/*
 * Badge — canonical status chip (the .badge pill). Semantic tones map to the
 * token-driven .badge-* classes.
 */
const TONE_CLASS = {
  gold: 'badge-gold',
  amber: 'badge-amber',
  green: 'badge-green',
  red: 'badge-red',
  grey: 'badge-grey',
};

export default function Badge({ tone = 'gold', className = '', children, ...props }) {
  const cls = ['badge', TONE_CLASS[tone] || TONE_CLASS.gold, className]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={cls} {...props}>
      {children}
    </span>
  );
}
